import { Alert } from "@interstate/components/Alert";
import { StyledContainerAlert } from "./styled";

export interface FileUploadErrorAlertProps {
  message: string;
}

export function FileUploadErrorAlert({ message }: FileUploadErrorAlertProps) {
  if (!message) {
    return null;
  }

  return (
    <StyledContainerAlert>
      <Alert
        id="MessageReplyWarning"
        role="info"
        title="File Upload Error"
        type="info"
      >
        {message}
      </Alert>
    </StyledContainerAlert>
  );
}
